function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_shell") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29.4,27.6H2.5V4.5H29.4Zm-25.9-1H28.4V5.5H3.5Z",
    style: {
      fill: "#d9b400"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.077 19.316 5.522 18.484 10.366 15.255 5.479 11.184 6.12 10.416 12.035 15.344 6.077 19.316",
    style: {
      fill: "#d9b400"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7,
    y: 18.2,
    width: 7.8,
    height: 1,
    style: {
      fill: "#d9b400"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 5.5,
    width: 26.9,
    height: 1.9,
    style: {
      fill: "#d9b400"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShell);
export default __webpack_public_path__ + "static/media/shell.d0b5149e216dccdc82b5b7415596d585.svg";
export { ForwardRef as ReactComponent };